import styled, { keyframes, css } from "styled-components";
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const tiltShaking = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(0); }
  75% { transform: translateX(5px); }
  100% { transform: translateX(0); }
`;

export const Container = styled(CardContainer)<{
    shouldShake?: boolean;
    containerBackground?: string;
    isHeaderDataPresent?: boolean;
}>`
    position: relative;
    margin: ${({ theme }) =>
        `${theme.spacing.empty} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`};
    ${({ shouldShake }) =>
        shouldShake &&
        css`
            animation: ${tiltShaking} 0.2s ease-in-out;
            animation-iteration-count: 2;
        `}

    ${({ containerBackground }) =>
        containerBackground &&
        css`
            background: ${containerBackground};
            border: 1px solid transparent;
        `}

    & > div {
        & > div:first-child {
            padding-left: ${({ theme }) => theme.spacing.medium};
        }
    }
`;

export const ContainerV2 = styled(CardContainer)<{
    containerBackground?: string;
    isHeaderDataPresent?: boolean;
}>`
    position: relative;
    margin: ${({ theme }) =>
        `${theme.spacing.empty} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`};
    padding: ${({ theme, isHeaderDataPresent }) =>
        `${!isHeaderDataPresent ? theme.spacing.medium : 0} 0 ${theme.spacing.medium}`};

    ${({ containerBackground }) =>
        containerBackground &&
        css`
            background: ${containerBackground};
            border: 1px solid transparent;
        `}
`;

export const Title = styled(Text)(({ theme }) => {
    return {
        paddingLeft: theme.spacing.small,
    };
});

export const WhiteOverlay = styled.div(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    pointerEvents: "none" as const,
    zIndex: 1,
    overflow: "hidden",
    borderRadius: theme.spacing.x8,
}));

export const LottieOverlayContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    zIndex: 2,
    pointerEvents: "none" as const,
    borderRadius: theme.spacing.x8,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& > button": {
        width: "100%",
        height: "100%",
    },

    "& > button > div": {
        width: "100%",
        height: "100%",
    },
}));
